/**
 * AppLink.tsx
 * Link into the app (login, dashboard, billing…) from a public page.
 * Renders a react-router <Link> on the app host and a plain absolute <a> on the
 * marketing host (catty.joinedupdata.io), where those routes are not served.
 */

import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { appUrl, isMarketingHost } from '../../config/site';

interface AppLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  to: string;
  children: ReactNode;
}

export function AppLink({ to, children, ...rest }: AppLinkProps) {
  if (isMarketingHost()) {
    return <a href={appUrl(to)} {...rest}>{children}</a>;
  }
  return <Link to={to} {...rest}>{children}</Link>;
}
